// extracted by mini-css-extract-plugin
module.exports = {"CHA_container":"HeroArea-module__CHA_container","CHA_text":"HeroArea-module__CHA_text","subTitle":"HeroArea-module__subTitle","title":"HeroArea-module__title"};